// NOTE: This default first month free coupon changes quite often, update the new code here when it does.
// If you need another type of discount, create a new constant and update the getCouponCodeForPlan function.
export const DEFAULT_40_DOLLARS_OFF_COUPON_CODE = "NEWYEAR";
export const DEFAULT_40_DOLLARS_OFF_SAVINGS_AMOUNT_CENTS = 4000;
export const FEB_40_DOLLARS_OFF_COUPON_CODE = "SPRINGPREP";

// For backwards compatibility, we need to support previous 40 dollars off coupon codes.
export const PREVIOUS_40_DOLLARS_OFF_COUPON_CODES = ["BTS40", "WINTER40"];

// If the referrer attribution has a coupon code, use it. Otherwise, use the a default coupon code.
// Dependency injection for referrer attribution coupon to avoid potential circular dependency issues.
export function getCouponCodeForPlan({
  referrerAttributionCouponCode,
  currentUser,
}: {
  referrerAttributionCouponCode?: string | null;
  currentUser?: {
    hasEverSubscribed: boolean;
  } | null;
}) {
  if (referrerAttributionCouponCode) {
    return referrerAttributionCouponCode;
  }
  // Don't apply any coupons below if the user has subscribed before.
  if (currentUser?.hasEverSubscribed) {
    return null;
  }

  return null;
}

export function getSavingsAmountCentsForCouponCode(
  couponCode: string | null,
  _priceAmountCents: number,
): number {
  if (!couponCode) {
    return 0;
  }
  if (
    couponCode === DEFAULT_40_DOLLARS_OFF_COUPON_CODE ||
    PREVIOUS_40_DOLLARS_OFF_COUPON_CODES.includes(couponCode)
  ) {
    return DEFAULT_40_DOLLARS_OFF_SAVINGS_AMOUNT_CENTS;
  }

  throw new Error(
    `Called getSavingsAmountCentsForCouponCode with invalid coupon code: ${couponCode}`,
  );
}
